import { Box } from '@chakra-ui/react';
import React from 'react';

const DeliveryRecent = () => <Box p="4">Delivery Recent</Box>;

export default DeliveryRecent;
